export default __webpack_public_path__ + "static/media/NIAS0480.34I-43107_-25777_0.e4ae10a8.jpg";